import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const listSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.list, {
        variants: {
            variant: {
                marker: {
                    root: {
                        listStyle: 'disc',
                    },
                    item: {
                        _marker: {
                            color: 'inherit',
                        },
                    },
                },

                separated: {
                    root: {
                        display: 'block',
                        listStyle: 'none',
                    },
                    item: {
                        _before: {
                            content: '"\u2022"',
                            mt: '-1px',
                            mr: 2,
                            color: 'var(--list-marker-color)',
                            transform: 'scale(1.25)',
                        },
                        '&:first-of-type': {
                            _before: {
                                display: 'none',
                            },
                        },
                        display: 'inline',
                        mr: 2,
                    },
                },
            },
        },
    }),
);
